import React from "react";

import { SimpleInfoModal } from "./SimpleInfoModal";

export class FeatureLockedModal extends React.Component {
  render() {
    const { isOpen, onClose } = this.props;

    return (
      <SimpleInfoModal
        title="Feature Locked"
        isOpen={isOpen}
        onClose={onClose}
        onAccept={onClose}
        content={
          <>
            <p>This feature is only available if you upgrade your account.</p>

            <p>
              If you would to schedule a demo to view these features, contact
              {" "}
              <a href="mailto:sales@loanboss.com">sales@loanboss.com</a>
              .
              <br />
              <br />
              Please contact your LoanBoss Administrator to upgrade or if you believe you are seeing this message in error:
              {" "}
              <a href="mailto:support@loanboss.com">support@loanboss.com</a>
              .
            </p>
          </>
        }
      />
    );
  }
}
